import * as React from 'react';
import EfFaqCollapse, { EfFaqCollapseItemProps, EfFaqCollapseProps } from '@elem/ui/ef-faq-collapse';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_AU = locale === 'au';
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph', 'nl'];
    const IS_EU_SITES = EU_SITES.includes(locale);
    const { pageStatus } = useProductStore();

    const EU_StatusB = IS_EU_SITES && pageStatus !== 'statusA';

    const tag = IS_AU || IS_NA_SITES || IS_EU_SITES ? 'EcoFlow App' : '';

    const specPic = React.useMemo(() => {
        if (locale === 'jp') return 'https://websiteoss.ecoflow.com/upload/image/1733143751972/JP--intput.jpg';
        if (['us', 'ca', ...EU_SITES].includes(locale)) return 'https://websiteoss.ecoflow.com/upload/image/1733144046752/EU-intput.jpg';
        return 'https://websiteoss.ecoflow.com/upload/image/1724662064656/a3.jpg';
    }, [locale]);

    const configs: EfFaqCollapseProps = {
        label: t('I_label'),
        title: t('I_title'),
        type: 'img',
        lists: [
            {
                img:
                    IS_NA_SITES || IS_EU_SITES || IS_AU
                        ? [
                              {
                                  pc: 'https://websiteoss.ecoflow.com/upload/image/1724677776818/a1.jpg',
                                  imgTitle: t('I_item1_img1'),
                              },
                              {
                                  pc: 'https://websiteoss.ecoflow.com/upload/image/1724677776985/a2.jpg',
                                  imgTitle: t('I_item1_img2'),
                              },
                          ]
                        : locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723607807682/JP-Storm.jpg'
                        : '',
                title: EU_StatusB ? t('I_item1_title2') : t('I_item1_title'),
                desc: t.rich(EU_StatusB ? 'I_item1_desc2' : 'I_item1_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img: specPic,
                title: EU_StatusB ? t('I_item2_title2') : t('I_item2_title'),
                desc: t.rich(EU_StatusB ? 'I_item2_desc2' : 'I_item2_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723607807627/JP-TOU.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1724662064367/a4.jpg',
                title: EU_StatusB ? t('I_item3_title2') : t('I_item3_title'),
                desc: t.rich(EU_StatusB ? 'I_item3_desc2' : 'I_item3_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
            {
                img:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1723607807616/JP-output.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1724662064804/a5.jpg',
                title: EU_StatusB ? t('I_item4_title2') : t('I_item4_title'),
                desc: t.rich(EU_StatusB ? 'I_item4_desc2' : 'I_item4_desc', {
                    y: (tx: string) => <span className="y">{tx}</span>,
                }),
                tag,
            },
        ] as EfFaqCollapseItemProps[],
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfFaqCollapse {...configs} />
        </div>
    );
}
